import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';

class CareProductsStepEight extends BaseComponent {
    constructor(element) {
        super(element);

        let recipientType = this.element.querySelector('select[name="type"]') || ''
        ,   insurant = this.element.querySelectorAll('.u-care-products__type--insurant')
        ,   attendant = this.element.querySelectorAll('.u-care-products__type--attendant')
        ,   legalAttendant = this.element.querySelectorAll('.u-care-products__type--legalAttendant')
        ,   other = this.element.querySelectorAll('.u-care-products__type--other')
        ,   packaging = this.element.querySelectorAll('.u-care-products__packaging')
        ,   selected = recipientType.options[recipientType.selectedIndex].value;
        ;

        const requiredFields = this.element.querySelectorAll('.u-care-products__type--other :required') || '';

        this.editButton = this.element.querySelectorAll('.u-edit--person');
        this.editModalContainer = document.querySelector('#editModal') || '';
        this.editModal = new Modal( this.editModalContainer );

        this.editButton.forEach( element => {
            element.addEventListener('click', (evt) => {
                this.editModal.handleModal('person','open', {id: element.dataset.id, contract: element.dataset.contract, headline: element.dataset.headline });
            });
        });

        this.blocks = {
            'insurant': insurant,
            'attendant': attendant,
            'legalAttendant': legalAttendant,
            'other': other,
            'packaging': packaging,
        };

        recipientType.addEventListener("change", (e) => { this.checkSelection( recipientType.value, requiredFields ); });

        this.checkSelection( selected, requiredFields );

    }

    onInit() {}

    checkSelection = (type, required) => {
        switch(type) {
            case 'insurant':
                this.showBlock(type);
                this.hideBlock('attendant');
                this.hideBlock('legalAttendant');
                this.hideBlock('other');
                this.showBlock('packaging');
                this.setBackground(true);
                break;
            case 'attendant':
                this.hideBlock('insurant');
                this.showBlock(type);
                this.hideBlock('legalAttendant');
                this.hideBlock('other');
                this.showBlock('packaging');
                this.setBackground(true);
                break;
            case 'legalAttendant':
                this.hideBlock('insurant');
                this.hideBlock('attendant');
                this.showBlock(type);
                this.hideBlock('other');
                this.showBlock('packaging');
                this.setBackground(true);
                break;
            case 'other':
                this.hideBlock('insurant');
                this.hideBlock('attendant');
                this.hideBlock('legalAttendant');
                this.showBlock(type);
                this.showBlock('packaging');
                this.setBackground(false);
                break;
            default:
                this.hideBlock('insurant');
                this.hideBlock('attendant');
                this.hideBlock('legalAttendant');
                this.hideBlock('other');
                this.hideBlock('packaging');
                this.setBackground(false);
        }

         // add/remove required attribte of formfields
         this.setRequiredFields(type, required);
    }

    showBlock = (type) => {
        this.blocks[type].forEach(function(ele) {
            ele.classList.remove('hidden');
        });
    }

    hideBlock = (type) => {
        this.blocks[type].forEach(function(ele) {
            ele.classList.add('hidden');
        });
    }

    setBackground = (bol) => {
        let pack = this.element.querySelector('.u-care-products__packaging');

        if (bol) {
            pack.classList.add('bg');
        } else {
            pack.classList.remove('bg');
        }
    }

    setRequiredFields = (state, required) => {

        // remove required attribute of formfields
        if ( state !== 'other' ) {
             required.forEach(ele => {
                 ele.removeAttribute("required");
             });
         }

         // add required attribute if not present
        if ( state === 'other' ) {
            required.forEach(ele => {
                if (!ele.hasAttribute("required")) {
                    ele.setAttribute("required","");
                }
            });
        }
    }
}

export default {
    name: 'CareProductsStepEight',
    definition: CareProductsStepEight
};